<template>
  <span>
    <slot name="func"></slot>
    <Modal v-model="openStatus" class-name="bsp-flow-modal" :width="670" :closable="false" :mask-closable="false">
      <div class="bsp-flow-modal-title" slot="header">
        <span style="font-size: 17px">{{ tit }}</span>
        <span @click="cancel" style="position: absolute; right: 6px; font-size: 32px; cursor: pointer">
          <i class="ivu-icon ivu-icon-ios-close"></i>
        </span>
      </div>
      <Form :label-width="120" label-colon class="form-ctnt" ref="approvalForm" label-position="right" :model="formValidate">
        <FormItem :label="bpmDefinition.length === 1 ? '已选流程' : '选择流程'" required>
          <Select v-model="actDefKey" filterable @on-select="onSelectFlow" :disabled="bpmDefinition.length === 1" style="width: 400px">
            <Option v-for="item in bpmDefinition" :value="item.defKey" :key="item.defKey">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="审核节点" required v-if="nextNodeList.length > 0">
          <Select v-model="selectNode" filterable @on-change="onSelectNode" style="width: 400px" :transfer="true">
            <Option v-for="item in nextNodeList" :value="item.nodeId" :key="item.nodeId">{{ item.nodeName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="呈报意见" prop="approvalContent" v-if="showCbyj && selectNode" :rules="{ required: true, message: '呈报意见不能为空', trigger: 'blur,change' }">
          <Input type="textarea" style="width: 400px" v-model="formValidate.approvalContent" placeholder="请输入呈报意见" />
        </FormItem>
        <FormItem label="审核部门" v-if="selectNode" style="background-color: #f2f6fc">
          <div class="uni-ctnt">
            <div class="uni-sel">
              <Select class="sel" style="width: 400px" v-model="selectOrgArr" filterable @on-select="orgSelectEvent" :transfer="true">
                <Option v-for="item in orgArr" :value="item.orgId" :key="item.orgId">{{ item.orgName }}</Option>
              </Select>
            </div>
            <div class="checkAll">
              <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">全选</Checkbox>
            </div>
            <div class="uni-list">
              <div style="float: left" v-for="orgItem in orgUserList" :key="orgItem.orgId">
                <CheckboxGroup v-model="candidateUsers" class="check" size="large" @on-change="checkAllGroupChange">
                  <Checkbox v-for="user in orgItem.user" :key="user.userIdCard + '_' + user.orgCode" :label="user.userIdCard + '_' + user.orgCode">{{ user.userName }}</Checkbox>
                </CheckboxGroup>
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem label="抄送" v-if="showcc && selectNode" style="background-color: #f2f6fc">
          <div style="background-color: #cee0f0; text-align: left; width: 400px; border: 1px solid #cee0f0">
            <div class="bsp-flow-people-ctnt scroll-able" style="padding: 8px; background: #fff">
              <Tag v-for="(item, i) in csldList" :key="item.idCard + '_' + item.orgCode" @on-close="csld_close(i)" type="dot" closable color="primary">{{ item.name }}</Tag>
              <user-selector ref="userSelector" tit="选择抄送人员" @onSelect="policeConfirm" :value="selectedUser" :orgCode="orgCode">
                <Button icon="md-add" class="bsp-sel-user" style="padding: 0 10px; margin-top: -1px" type="dashed" slot="func">添加人员</Button>
              </user-selector>
            </div>
          </div>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="cancel" class="cancle-button">取&nbsp;消</Button>&nbsp;
        <Button @click="start('approvalForm')" :loading="loading" type="primary" class="submit-button">确&nbsp;认</Button>
      </template>
    </Modal>
  </span>
</template>
<script>
import { userSelector } from 'sd-user-selector'
// import userSelector from '../../../src/components/start-approval/start-approval'

export default {
  name: 'start-approval',
  props: {
    businessId: {
      type: String,
      default: ''
    },
    operType: {
      type: String,
      default: '1'   //新增 0  编辑 1
    },
    formId: {
      type: String,
      default: ''  //1858415537667837952
    },
    msgTit: {
      type: String,
      default: ''
    },
    msgUrl: {
      type: String,
      default: ''
    },
    sponsor: {
      type: String,
      default: ''
    },
    sponsorOrg: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      default: ''
    },
    variables: {
      type: Object,
      default: function () {
        return {}
      }
    },
    platform: {
      type: String,
      default: 'pc'
    },
    definition: {
      type: Array,
      default: function () {
        return []
      }
    },
    beforeOpen: {
      // 打开启动流程组件钱事件
      type: Function,
      default: null
    },
    startUpSuccess: {
      type: Function,
      default: null
    },
    beforeSatrtUp: {
      type: Function,
      default: null
    },
    error: {
      type: Function,
      default: null
    },
    isDelProcInst: {
      // 流程启动失败是否删除流程实例
      type: Boolean,
      default: true
    },
    delProcInstCallback: {
      type: Function,
      default: null
    },
    showcc: {
      type: Boolean,
      default: true
    },
    tit: {
      type: String,
      default: '提交审批'
    },
    bindEvent: {
      type: Boolean,
      default: true
    },
    orgCode: {
      type: String,
      default: ''
    },
    assigneeUserId: {
      type: String,
      default: ''
    },
    assigneeUserName: {
      type: String,
      default: ''
    },
    assigneeOrgId: {
      type: String,
      default: ''
    },
    assigneeOrgName: {
      type: String,
      default: ''
    },
    assigneeAreaId: {
      type: String,
      default: ''
    },
    assigneeAreaName: {
      type: String,
      default: ''
    },
    extraOrgId: {
      type: String,
      default: ''
    },
    extraRegId: {
      type: String,
      default: ''
    },
    selectUsers: {
      type: String,
      default: ''
    },
    extraCityId: {
      type: String,
      default: ''
    },
    showCbyj: {
      type: Boolean,
      default: false
    },
    approvalContent: {
      type: String,
      default: ''
    }
  },
  components: {
    userSelector
  },
  data() {
    return {
      bootData: {},
      isInitData: false,
      openStatus: false,
      nodeName: '部门',
      loading: false,
      indeterminate: false,
      checkAll: true,
      bpmDefinition: [],
      orgUserList: [],
      actDefKey: '',
      actDefName: '',
      orgId: '',
      userList: [],
      candidateUsers: [],
      csldList: [], // 抄送领导
      selectedUser: '',
      selectNode: '',
      nextNodeList: [],
      // 所选择的节点是否需要法制审核
      selectNodeSffzsh: false,
      formValidate: {
        approvalContent: this.approvalContent
      },
      orgArr: [],
      selectOrgArr: [],
      formArr:[],
      formData:{},
      ProcessVarObj:{}
    }
  },
  mounted() {
    if (this.bindEvent && this.$slots.func) {
      this.reference = this.$slots.func[0].elm
      this.reference.addEventListener('click', this.openStartApproval)
    }
  },
  watch: {
    approvalContent(value) {
      this.formValidate.approvalContent = value
    }
  },
  methods: {
    openStartApproval() {
      if (this.beforeOpen) {
        
        this.beforeOpen().then(data => {
          if (data) {
            this.formId?this.getForm():this.initData()

          }
        })
      } else {
        this.formId?this.getForm():this.initData()

      }
      
    },
    getFormField(){
      if(this.formId){
        this.$store.dispatch('postRequest', { url: '/bsp-com/com/form/getFormFieldByFormId', params: { formId: this.formId } }).then(resp => {
          if (resp.success) {
            if(resp.data && resp.data.length>0){
                    resp.data.forEach(item=>{
                      if(item.isMain=='1'){
                        this.formArr=item.children
                        let obj={}
                        let keyName=''
                        this.formArr.forEach(ele=>{
                           if(ele.isProcessVar && ele.isProcessVar=='1'){
                              keyName=ele.fieldName
                              obj[keyName]=this.formData[ele.fieldName]
                           }
                        })
                        this.ProcessVarObj=obj
                      }
                    })
                    this.initData()
                  }else{
                    this.initData()
                  }
          }
        })
      }
    },
    getForm(){
            let params={
              operType: this.operType,
              formId: this.formId,
              businessId: this.businessId
            }
            this.$store.dispatch('postRequest', { url: '/bsp-com/com/form/handle/getFormData', params: params }).then(resp => {
                if (resp.success) {
                  console.log(resp,resp.success,'resp.data')
                  this.formData=resp.formData
                  this.getFormField()
                  
                } else {
                    this.warnSwal('文书模版加载出错。原因:'+ resp.msg)
                }
            })
        
    },
    initData() {
      // 清空抄送人员
      this.csldList = []
      if (this.isInitData) {
        this.openStatus = true
      } else {
        if (this.definition.length < 1) {
          this.warnSwal('未设置流程。')
          return
        }
        if (this.businessId === '') {
          this.warnSwal('未设置业务编号[businessId]。')
          return
        }
        if (this.module === '') {
          this.warnSwal('未设置模块名称[module]。')
          return
        }
        this.bootData = {
          definition: this.definition,
          businessId: this.businessId,
          fApp: this.module,
          fXxpt: this.platform,
          variables: this.variables,
          zbrUserId: this.sponsor,
          zbrOrgId: this.sponsorOrg,
          msgUrl: this.msgUrl,
          msgTit: this.msgTit,
          assigneeUserId: this.assigneeUserId,
          assigneeUserName: this.assigneeUserName,
          assigneeOrgId: this.assigneeOrgId,
          assigneeOrgName: this.assigneeOrgName,
          assigneeAreaId: this.assigneeAreaId,
          assigneeAreaName: this.assigneeAreaName
        }
        this.initDefiniton(this.bootData.definition)
      }
    },
    warnSwal(msg, callback) {
      this.$Modal.warning({
        title: '温馨提示',
        content: msg
      })
    },
    // 判断所选择的节点是否需要法制审核
    justFzshNextNode() {
      if (this.selectNode) {
        this.$store.dispatch('postRequest', { url: '/bsp-bpm/bpm/nodeSetting/isFzsh', params: { defKey: this.actDefKey, nodeId: this.selectNode } }).then(resp => {
          if (resp.success) {
            // 是否需要法制审核
            this.selectNodeSffzsh = resp.sffzsh
          }
        })
      }
    },
    initDefiniton(bpmDefinition) {
      if (bpmDefinition.length < 1) {
        this.warnSwal('未配置流程。')
        return
      }
      this.bpmDefinition = bpmDefinition
      this.actDefKey = bpmDefinition[0].defKey
      this.actDefName = bpmDefinition[0].name
      this.getOrgUserList(this.actDefKey, null, this.bootData.assigneeUserId)
    },
    getOrgUserList(actDefKey, actInstId, userId) {
      // if (!userId) userId = this.$store.state.common.idCard;
      let url = ''
      let param = {}
      let formProcessVar=''
      this.formId?formProcessVar=JSON.stringify(this.ProcessVarObj):''
      if (actInstId) {
        // 审批过程获取用户信息
        url = '/bsp-bpm/bpm/approveProcess/getApproveUser'
        param = { actInstId: actInstId, userId: userId,formProcessVar:formProcessVar }
      } else {
        url = '/bsp-bpm/bpm/approveProcess/getStartApproveUser'
        param = {
          defKey: actDefKey,
          startUserId: userId,
          startRegId: this.bootData.assigneeAreaId,
          startOrgId: this.bootData.assigneeOrgId,
          extraOrgId: this.extraOrgId,
          extraRegId: this.extraRegId,
          extraCityId: this.extraCityId,
          zbrUserId: this.bootData.zbrUserId,
          zbrOrgId: this.bootData.zbrOrgId,
          formProcessVar:formProcessVar 
        }
      }
      this.$store.dispatch('postRequest', { url: url, params: param }).then(data => {
        if (data.success && data.data.length > 0) {
          this.openStatus = true
          this.isInitData = true
          let nodeData = data.data[0]
          if (nodeData.nodeType == 'exclusiveGateway') {
            this.nextNodeList = nodeData.orgUserList
            // 默认选中第一个节点
            // this.selectNode = this.nextNodeList[0].nodeId
            // this.nodeName = this.nextNodeList[0].nodeName
            // this.orgUserList = this.nextNodeList[0].orgUser
            // this.clearCheckbox()
            // 判断所选择的节点是否需要法制审核
            // this.justFzshNextNode()
            return
          }
          // 当下一节点不是排它网关时
          this.selectNode = nodeData.nodeId
          // 判断下一节点是否需要法制审核
          // this.justFzshNextNode()

          let orgUserList = nodeData.orgUserList
          this.orgArr = orgUserList

          // 默认选中第一项
          if (orgUserList && orgUserList.length > 0) {
            let selectOrg = this.getSelectOrg(orgUserList, this.extraOrgId, this.extraRegId)
            this.orgSelectEvent({
              label: selectOrg.orgName,
              value: selectOrg.orgId
            },true)
            this.selectOrgArr = []
            this.selectOrgArr.push(selectOrg.orgId)
          }
        } else {
          this.warnSwal(data.msg)
        }
      })
    },
    onSelectNode(nodeId) {
      this.nextNodeList.forEach(item => {
        if (item.nodeId == nodeId) {
          this.orgArr = item.orgUser
        }
      })
      // 清空单位值，清空复选框
      /* this.orgUserList = []
          this.selectOrgArr = [] */
      // 默认选中第一项
      if (this.orgArr && this.orgArr.length > 0) {
        this.orgSelectEvent({
          label: this.orgArr[0].orgName,
          value: this.orgArr[0].orgId
        })
        this.selectOrgArr = []
        this.selectOrgArr.push(this.orgArr[0].orgId)
      }

      // 判断所选择的节点是否需要法制审核
      // this.justFzshNextNode()
    },
    getSelectOrg(orgUserList, extraOrgId, extraRegId) {
      let extraOrgIdArr = extraOrgId ? extraOrgId.split(',') : []
      let extraRegionIdArr = extraRegId ? extraRegId.split(',') : []
      // 先根据机构id匹配
      for (let i in extraOrgIdArr) {
        let matchOrgIdVal = extraOrgIdArr[i]
        for (let j in orgUserList) {
          let item = orgUserList[j]
          if (matchOrgIdVal === item['orgId']) {
            return item
          }
        }
      }
      // 根据机构id没有匹配到时再根据区域id匹配
      for (let i in extraRegionIdArr) {
        let matchRegionId = extraRegionIdArr[i]
        for (let j in orgUserList) {
          let item = orgUserList[j]
          if (matchRegionId === item['regId']) {
            return item
          }
        }
      }
      // 都没匹配到就默认第一个
      return orgUserList[0]
    },
    orgSelectEvent(option,selectTag) {
      let index = this.orgArr.findIndex(item => {
        return item.orgId == option.value
      })
      this.orgUserList = []
      this.candidateUsers = []
      this.orgUserList.push(this.orgArr[index])
      // 默认全选
      this.indeterminate = false
      this.checkAll = true
      if(this.selectUsers && selectTag){
        let selectUsersArr=this.selectUsers.split(',')
        this.orgArr[index].user.map((item) =>
          selectUsersArr.forEach(ele=>{
             if(item.userIdCard== ele){
              this.candidateUsers.push(item.userIdCard + '_' + item.orgCode)
             }
          })
        )
        // 如果默认人员不存在 设置全选
        if(this.candidateUsers && this.candidateUsers.length==0){
          this.orgArr[index].user.map((item) =>
            this.candidateUsers.push(item.userIdCard + '_' + item.orgCode)
          )
        }
        if(this.candidateUsers.length == this.orgArr[index].user.length){
          this.indeterminate = false
          this.checkAll = true
        }else{
          this.indeterminate = true
          this.checkAll = false
        }
      }else{
        this.orgArr[index].user.map((item) =>
            this.candidateUsers.push(item.userIdCard + '_' + item.orgCode)
        )
      }
      // this.orgArr[index].user.map(item => this.candidateUsers.push(item.userIdCard + '_' + item.orgCode))
    },
    onSelectFlow(data) {
      let actDefKey = data.value
      let index = this.bpmDefinition.findIndex(item => item.defKey == actDefKey)
      if (index > -1) {
        this.actDefKey = this.bpmDefinition[index].defKey
        this.actDefName = this.bpmDefinition[index].name
      }
      // 清空单位值，清空复选框
      this.orgArr = []
      this.orgUserList = []
      this.candidateUsers = []
      this.selectOrgArr = []
      this.nextNodeList = []
      this.selectNode = ''
      this.getOrgUserList(this.actDefKey, null, this.bootData.assigneeUserId)
    },
    convertCandidateUsers() {
      return this.candidateUsers.map(item => {
        let array = item.split('_')
        return {
          idCard: array[0],
          orgCode: array[1]
        }
      })
    },
    convertCsldbh() {
      return this.csldList.map(item => {
        return {
          idCard: item.idCard,
          orgCode: item.orgCode
        }
      })
    },
    async submit() {
      let exParam = {
        actDefKey: this.actDefKey,
        candidateUsers: this.convertCandidateUsers(),
        csldbh: this.convertCsldbh(),
      }
      this.formId?exParam.formProcessVar=JSON.stringify(this.ProcessVarObj):''
      this.bootData.variables.nextNodeId = this.selectNode
      let param = Object.assign(this.bootData, exParam)
      if (this.showCbyj) {
        param.approvalContent = this.formValidate.approvalContent
      }
      this.$store
        .dispatch('postRequest', {
          url: '/bsp-bpm/bpm/approveProcess/startProcess',
          params: { processCmd: JSON.stringify(param) }
        })
        .then(data => {
          if (data.success) {
            console.log(data.data,data.data.bpmTrail.taskId,'data.datadata.datadata.data.bpmProcinst.actDefId')
            let bmpData = {
              actDefId: data.data.bpmProcinst.actDefId,
              businessId: data.data.bpmProcinst.businessId,
              actInstId: data.data.bpmProcinst.actInstId,
              taskId: data.data.bpmTrail.taskId,   //成功回调新增taskId
              defId: data.data.bpmProcinst.defId,
              defKey: data.data.defKey
            }
            if (this.startUpSuccess) {
              this.startUpSuccess(bmpData).then(d => {
                this.loading = false
                if (d) {
                  this.cancel()
                  this.isInitData = false
                } else {
                  // 删除流程示例
                  if (this.isDelProcInst) {
                    let _that = this
                    _that.deleteProcInst(bmpData.actInstId, function (dd) {
                      if (_that.delProcInstCallback) {
                        _that.delProcInstCallback(dd)
                      }
                    })
                  }
                }
              })
            } else {
              this.cancel()
              this.isInitData = false
              this.$Modal.success({
                title: '温馨提示',
                content: '流程启动成功。'
              })
            }
          } else {
            alert(data.msg)
            this.loading = false
            if (this.error) {
              this.error(data)
            } else {
              this.$Modal.error({
                title: '温馨提示',
                content: data.msg
              })
            }
          }
        })
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false
      if (this.checkAll) {
        this.orgUserList.forEach(item => {
          item.user.forEach(item => {
            this.candidateUsers.push(item.userIdCard + '_' + item.orgCode)
          })
        })
      } else {
        this.candidateUsers = []
      }
    },
    checkAllGroupChange(data) {
      let count = 0
      this.orgUserList.forEach(item => {
        item.user.forEach(item => {
          count++
        })
      })
      if (data.length === count) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },
    cancel() {
      this.openStatus = false
      this.loading = false
      this.isInitData = false
    },
    start(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (!this.customizeValidate()) return
          this.loading = true
          if (this.beforeSatrtUp) {
            this.beforeSatrtUp(this.actDefKey, this.convertCandidateUsers()).then(data => {
              if (data) {
                this.submit()
              } else {
                this.loading = false
              }
            })
          } else {
            this.submit()
          }
        } else {
          this.$Notice.error({
            title: '错误提示',
            desc: '表单验证不通过'
          })
        }
      })
    },
    // 自定义验证
    customizeValidate() {
      let validate = true
      /* if (!this.actDefKey) {
        this.$Modal.warning({
          title: '温馨提示',
          content: '请选择审批流程。'
        })
        validate = false
      } */
      if (!this.selectNode) {
        this.$Modal.warning({
          title: '错误提示',
          content: '审核节点不能为空'
        })
        validate = false
      } else if (!this.candidateUsers || this.candidateUsers.length === 0) {
        this.$Modal.warning({
          title: '温馨提示',
          content: '请选择审批人。'
        })
        validate = false
      }
      return validate
    },
    // 删除抄送人
    csld_close(idx) {
      this.csldList.splice(idx, 1)
    },
    // 选择抄送人回调
    policeConfirm(policeList) {
      this.csldList = policeList
      let _that = this
      _that.selectedUser = ''
      _that.csldList.map((item, index) => {
        if (index != 0) {
          _that.selectedUser += ','
        }
        _that.selectedUser += item.idCard
      })
    },
    deleteProcInst(actInstId, callback) {
      this.$store.dispatch('postRequest', { url: '/bsp-bpm/bpm/procinst/deleteByActInstIds', params: { actInstIds: actInstId } }).then(data => {
        if (callback) {
          callback(data)
        }
      })
    }
  }
}
</script>
<style scoped>
.uni-ctnt {
  /* background-color: #f7fafe; */
  padding: 5px 0 20px 0;
  position: relative;
}
.uni-ctnt .checkAll {
  margin-top: 10px;
  max-height: 100px;
  position: absolute;
  left: -75px;
}
.uni-sel {
  display: flex;
}
.uni-sel > .sel {
  width: 80%;
}
.uni-sel > .check {
  width: 20%;
  margin-left: 20px;
}
.uni-list {
  margin-top: 10px;
  max-height: 200px;
  overflow: auto;
  width: 500px;
}

.bsp-flow-modal .bsp-flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
  font-size: 15px;
}

.bsp-flow-modal .bsp-flow-people-ctnt {
  /* min-height: 56px; */
  /* max-height: 100px; */
  /* overflow: auto; */
}
.bsp-flow-people-ctnt > div {
  display: inline-block;
}

.bsp-flow-modal *::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.bsp-flow-modal *::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 3px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #c9c9c9;
}

.bsp-flow-modal *::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background: #ededed;
}

.cancle-button,
.submit-button {
  min-width: 60px;
  /* height:30px;
    line-height: 30px; */
  font-size: 14px;
  border-radius: 0;
}

.cancle-button {
  border: 1px solid #2b5fd9;
  color: #2b5fd9;
  background-color: #ffffff;
}

.submit-button {
  border: 1px solid #2b5fd9;
  color: #ffffff;
  background-color: #2b5fd9;
}

.tip-container {
  margin-top: 10px;
  background-color: #f2f6fc;
  padding: 16px;
}
.tip-container .tip-title {
  font-size: 16px;
  font-weight: bold;
  padding-right: 10px;
}

.tip-container .tip-warning {
  color: #e60012;
  font-weight: 16px;
}

.tip-container p {
  font-size: 16px;
  margin: 20px;
}
</style>

<style>
.bsp-flow-modal .ivu-modal-header {
  padding: 0;
}

.bsp-flow-modal .ivu-icon-ios-close {
  font-size: 32px;
}

/* 修改tag样式 */
.bsp-flow-modal .ivu-tag-text {
  font-size: 16px;
}
.bsp-flow-modal .ivu-tag-dot {
  padding: 0 8px;
}
.bsp-flow-modal .ivu-tag-dot-inner {
  margin-right: 2px;
}
.bsp-flow-modal .ivu-tag .ivu-icon-ios-close {
  font-size: 18px;
  top: 1px;
  margin-left: 4px !important;
}

.bsp-flow-modal .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

.bsp-flow-modal textarea.ivu-input {
  font-size: 16px;
  height: 80px;
}

.bsp-flow-modal .ivu-form-item-error-tip {
  position: inherit;
}

.bsp-flow-modal .bsp-sel-user .ivu-icon-md-add {
  font-size: 18px;
}
.bsp-flow-modal .bsp-sel-user > .ivu-icon + span,
.bsp-flow-modal .bsp-sel-user > span + .ivu-icon {
  margin-left: 0px;
  font-size: 16px;
}

.bsp-flow-modal .ivu-select-input {
  font-size: 16px;
}

.bsp-flow-modal .ivu-select-item {
  font-size: 16px !important;
}

.bsp-flow-modal .ivu-checkbox-wrapper {
  font-size: 16px;
}

.bsp-flow-modal .ivu-form-item {
  margin-bottom: 0px;
  padding-bottom: 10px;
}

.bsp-flow-modal .ivu-modal-body {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}

.bsp-flow-modal .ivu-modal-footer {
  height: 50px;
  line-height: 50px;
  padding: 0px 12px;
}
</style>


// WEBPACK FOOTER //
// src/component/start-approval/start-approval.vue